import { useTranslation } from 'react-i18next';

import { LoginFrame } from './LoginFrame';
import { LoginWidgetProps } from './LoginWidget';
import { ResetForm } from './ResetForm';

export type ResetPasswordWidgetProps = {
  isSso?: boolean;
  onBackToLogin: () => void;
  onEnterValidEmail?: LoginWidgetProps['onEnterValidEmail'];
  onSubmit: (email: string) => Promise<void>;
  error?: string;
};

export function ResetPasswordWidget({
  isSso = false,
  onBackToLogin,
  onEnterValidEmail,
  onSubmit,
  error,
}: ResetPasswordWidgetProps) {
  const { t } = useTranslation();

  return (
    <LoginFrame title={t('app.resetWidget.title')}>
      <ResetForm
        isSso={isSso}
        onBackToLogin={onBackToLogin}
        onEnterValidEmail={onEnterValidEmail}
        onSubmit={onSubmit}
        error={error}
      />
    </LoginFrame>
  );
}
